(function ensureURLParseShim() {
  try {
    // Only add if missing
    if (typeof window !== 'undefined' && typeof window.URL === 'function' && typeof window.URL.parse !== 'function') {
      // Minimal compatible behavior for code that expects url.parse(url)
      // Returns an object shaped similarly to Node's url.parse
      window.URL.parse = function (input) {
        // Use document origin as base for relative inputs
        const base = (typeof window !== 'undefined' && window.location) ? window.location.origin : 'http://localhost';
        const u = new window.URL(input, base);
        return {
          href: u.href,
          protocol: u.protocol,
          slashes: u.href.includes('://'),
          auth: null,
          host: u.host,
          port: u.port || null,
          hostname: u.hostname,
          hash: u.hash,
          search: u.search,
          query: u.search ? u.search.slice(1) : null,
          pathname: u.pathname,
          path: u.pathname + u.search,
        };
      };
    }
  } catch (e) {
    // no-op: never block app startup
  }
})();